<template>
  <div>
    <seg-carousel
      :item-top="false"
      :height="bannerHeight"
      :modal-shadow="false"
      :imgs="[{'src': require('@/assets/img/about-us/banner-back.png')}]"
      indicator-position="none"
    >
      <template v-slot:modal-layer>
        <pull-down-notice-arrow
          v-if="['AboutUsCatePage'].includes($route.name)"
          style="left: calc(50% - 15px);"
        />
      </template>
    </seg-carousel>
    <router-view :style="{'min-height': !['AboutUsCatePage'].includes($route.name) ? 'calc(100vh - 100px)' : 'auto'}" />
    <seg-main
      style="display: flex; align-items: center; justify-content: center;height: 720px;"
      :style="{background: `url('${require('@/assets/img/about-us/矩形 22 拷贝.png')}') center`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}"
    >
      <div class="bottom-block">
        <div class="block-row">
          <div class="block-item with-text">
            <div class="item-body">
              <div class="item-topic">
                愿景
              </div>
              <div class="item-desc">
                铸就万豪品质
              </div>
              <div class="item-desc">
                建设国内一流专业化咨询机构
              </div>
            </div>
          </div>
          <div
            class="block-item"
            :style="{background: `url('${require('@/assets/img/about-us/bottom-block1.png')}')`}"
          />
          <div class="block-item with-text">
            <div class="item-body">
              <div class="item-topic">
                精神
              </div>
              <div class="item-desc">
                团结拼搏 追求卓越
              </div>
              <div class="item-desc">
                励精图治 高质高效
              </div>
            </div>
          </div>
          <div
            class="block-item"
            :style="{background: `url('${require('@/assets/img/about-us/bottom-block2.png')}')`}"
          />
        </div>
        <div class="block-row">
          <div
            class="block-item"
            :style="{background: `url('${require('@/assets/img/about-us/bottom-block3.png')}')`}"
          />
          <div class="block-item with-text">
            <div class="item-body">
              <div class="item-topic">
                理念
              </div>
              <div class="item-desc">
                业务是龙头 质量是生命
              </div>
              <div class="item-desc">
                人才是根本
              </div>
            </div>
          </div>
          <div
            class="block-item"
            :style="{background: `url('${require('@/assets/img/about-us/bottom-block4.png')}')`}"
          />
          <div class="block-item with-text">
            <div class="item-body">
              <div class="item-topic">
                原则
              </div>
              <div class="item-desc">
                严谨 诚信
              </div>
              <div class="item-desc">
                独立 客观 公正
              </div>
            </div>
          </div>
        </div>
      </div>
    </seg-main>
  </div>
</template>

<script>
import SegCarousel from '@/components/indexTopCarousel/segCarousel';
import PullDownNoticeArrow from '@/components/pullDownNoticeArrow/pullDownNoticeArrow';
import {menu} from '@/constant';
import SegMain from '@/components/segPart/segMain';
export default {
  name: 'Index',
  components: {SegMain, PullDownNoticeArrow, SegCarousel},
  computed: {
    bannerHeight: function() {
      if(!['AboutUsCatePage'].includes(this.$route.name)) {
        return '360px'
      }
      return '500px'
    },
    menu: function () {
      return menu[1].children
    }
  },
  watch: {
    $route: {
      handler: function () {
        if(!['AboutUsCatePage'].includes(this.$route.name)){
          if(window) {
            window.scrollTo(0,400)
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped lang="less">

  .bottom-block {
    .block-row {
      display: flex;
      justify-content: center;
      > div{
        width: 260px;
        height: 260px;
      }
      .block-item.with-text{
        &:hover{
          background:rgba(230,6,31,1);
        }
      }
      .block-item{
        display: flex;
        align-items: flex-end;
        color:rgba(255,255,255,1);
        background:rgba(34,34,34,1);
        .item-body{
          padding: 40px 26px;
          .item-topic{
            font-size:26px;
            font-weight:500;
            line-height:22px;
            margin-bottom: 27px;
          }
          .item-desc{
            font-size:16px;
            font-weight:500;
            line-height:22px;
          }
        }
      }
    }
  }
</style>
